import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};
const SvgInfoEllipseIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      style={{ WebkitTransform: `scale(${size / 40})` }}
      {...props}
    >
      <path
        d="M20 2C10.056 2 2 10.056 2 20s8.056 18 18 18 18-8.056 18-18S29.944 2 20 2Zm-2.564 9.15c0-.3.234-.534.534-.534h4.06c.3 0 .534.234.534.534v4.06c0 .3-.234.534-.534.534h-4.06a.528.528 0 0 1-.534-.534v-4.06Zm5.154 18.846c0 .299-.234.533-.534.533h-4.112a.528.528 0 0 1-.534-.533V18.894c0-.3.234-.534.534-.534h4.112c.3 0 .534.234.534.534v11.102Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};
export default SvgInfoEllipseIcon;
